import type { EventRunnerType } from "app/types/eventType";
import cx from "classnames";
import React, { Component } from "react";
import { connect } from "react-redux";
import "./AsianOdds.scss";
import AsianOddsPriceContainer from "./components/AsianOddsPriceContainer/AsianOddsPriceContainer";

type Props = {
  odds: number;
  onClickPrice?: (...args: Array<any>) => any;
  className: string;
  user: Record<string, any>;
  runner: EventRunnerType;
  size?: string;
  marketType?: string;
};
type State = {
  oddsUp: boolean;
  oddsDown: boolean;
  animationRunning: boolean;
  count: number;
};

class AsianOdds extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      oddsUp: false,
      oddsDown: false,
      animationRunning: false,
      count: 0,
    };
  }

  onAnimationEnd() {
    this.setState({
      oddsUp: false,
      oddsDown: false,
      animationRunning: false,
    });
  }

  onAnimationStart() {
    this.setState({
      animationRunning: true,
    });
  }

  componentDidUpdate(prevProps) {
    const oddsUp = this.props.odds > prevProps.odds;
    const oddsDown = this.props.odds < prevProps.odds;
    const count = this.state.count + 1;

    // Odds animation: if price changes again while animation is still running, need to start a new animation
    // Use a count so that every second time this component is rendered, show an alternate animation
    if (prevProps.odds !== this.props.odds) {
      this.setState({
        oddsUp: oddsUp,
        oddsDown: oddsDown,
        count,
      });
    }
  }
  generateQAID(runner: EventRunnerType, marketType: string | undefined) {
    // generate an id to be used by QA for automation testing
    // eg: "QA__HANDICAP__HOME__ODDS"
    // Works for main markets when marketType is passed in as a prop
    // if marketType is not passed in ie is undefined then id is not added
    const runnerSideOrType = runner.side === "NA" ? runner.type : runner.side;
    let QAID = "";
    if (marketType && runnerSideOrType) {
      QAID = `QA__${marketType}__${runnerSideOrType}__ODDS`;
    }
    return QAID;
  }

  render() {
    const { odds, onClickPrice, className, user, runner, size, marketType } =
      this.props;
    const userOddsType: any =
      user &&
      user.preferences &&
      user.preferences["oddsType"] !== undefined &&
      user.preferences["oddsType"].toLowerCase();
    const runnerStatus = runner ? runner.status.toLowerCase() : "";

    if (
      !runner ||
      !runner["aggregatedPrices"] ||
      (runner["aggregatedPrices"] && runner["aggregatedPrices"].length === 0)
    ) {
      return (
        <div className="asian-odds-empty">
          <span className="asian-odds-empty__child">-</span>
        </div>
      );
    }
    const qaid = this.generateQAID(runner, marketType);
    return (
      <React.Fragment>
        <div
          className={cx(`asian-odds-outer asian-odds-outer__${runnerStatus}`, {
            "asian-odds-outer__small": size && size === "small",
          })}
          data-qa={qaid ? qaid : undefined}
        >
          <div className={cx("asian-odds", className)}>
            <div
              className={cx(``, {
                "asian-odds__updated asian-odds__updated--shortened":
                  this.state.oddsDown === true && this.state.count % 2 === 0,
                "asian-odds__updated asian-odds__updated--improved":
                  this.state.oddsUp === true && this.state.count % 2 === 0,
                "asian-odds__updated--alternate asian-odds__updated--alternate--shortened":
                  this.state.oddsDown === true && this.state.count % 2 !== 0,
                "asian-odds__updated--alternate asian-odds__updated--alternate--improved":
                  this.state.oddsUp === true && this.state.count % 2 !== 0,
              })}
              onAnimationEnd={() => this.onAnimationEnd()}
              onAnimationStart={() => this.onAnimationStart()}
              onClick={onClickPrice}
            />
            <AsianOddsPriceContainer
              onClickPrice={onClickPrice}
              odds={odds}
              oddsType={userOddsType}
              size={size}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userModel.user,
});

export default connect(mapStateToProps, null)(AsianOdds) as any;
